module.exports = __webpack_public_path__ + "img/transfer-table-icon.4509bc08.svg";